import { BaseFilterOptions, BaseFilters, FilterOption, Questionnaire } from "../../models/types";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";

export const publicQuestionnairesListFilterOptions: FilterOption<BaseFilters>[] = [
  { label: "Name", value: "name" },
  ...BaseFilterOptions,
];

export const publicQuestionnairesListColumnVisibility: IColumnVisibility<Questionnaire>[] = [
  {
    field: "name",
    headerName: "Name",
    visible: true,
  },
  // {
  //   field: "questionnaire_type",
  //   headerName: "Type",
  //   visible: true,
  //   renderer: (r) => {
  //     return <DefaultBadge value={r?.questionnaire_type?.replace(/_/gi, " ") ?? ""} />;
  //   },
  // },
];
